import type { ComponentProps } from 'react';
import { mergeStyling } from '../common-functions';

export const FieldDescription = ({ className, ...props }: ComponentProps<'p'>) => {
  return <p className={mergeStyling('text-muted-foreground text-xs', className)} {...props} />;
};
